/** Indian mobile: 10 digits starting with 6–9. Accepts +91 / 91 / leading 0 prefixes. */

const INDIAN_MOBILE_RE = /^[6-9]\d{9}$/;

export function digitsOnlyPhone(value) {
  return String(value ?? '').replace(/\D/g, '');
}

/**
 * Reduce common Indian formats to a 10-digit mobile (no country code).
 * +919603154199 → 9603154199, 09603154199 → 9603154199
 */
export function normalizeIndianMobileDigits(value) {
  let digits = digitsOnlyPhone(value);
  if (!digits) return '';

  if (digits.length === 12 && digits.startsWith('91')) {
    digits = digits.slice(2);
  } else if (digits.length === 11 && digits.startsWith('0')) {
    digits = digits.slice(1);
  } else if (digits.length > 10) {
    const withCc = digits.match(/^91([6-9]\d{9})$/);
    if (withCc) {
      digits = withCc[1];
    } else {
      const tail = digits.slice(-10);
      if (INDIAN_MOBILE_RE.test(tail)) digits = tail;
    }
  }

  return digits;
}

export function isValidIndianMobile(value) {
  const digits = normalizeIndianMobileDigits(value);
  return digits.length === 10 && INDIAN_MOBILE_RE.test(digits);
}

export function isValidPhone(value, { exactTen = false } = {}) {
  if (exactTen) return isValidIndianMobile(value);
  const digits = digitsOnlyPhone(value);
  if (digits.length >= 10 && digits.length <= 15) return true;
  return isValidIndianMobile(value);
}
